import React, { useState } from 'react';
import { Button, Menu, MenuItem, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import flagIL from '../../assets/flags/Flag_of_Israel.svg';
import flagUK from '../../assets/flags/Flag_of_the_United_Kingdom.svg';

const languages = [
  { code: 'en', label: 'English', flag: flagUK },
  { code: 'he', label: 'עברית', flag: flagIL },
];

const FlagImg = ({ src, alt }) => (
  <img
    src={src}
    alt={alt}
    style={{ width: 22, height: 16, objectFit: 'cover', borderRadius: 2, display: 'block' }}
  />
);

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    handleClose();
  };

  const current = languages.find(l => l.code === i18n.language) || languages[0];

  return (
    <>
      <Button
        color="inherit"
        onClick={handleClick}
        sx={{ minWidth: 0, gap: 1, px: 1.5 }}
      >
        <FlagImg src={current.flag} alt={current.label} />
        <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>
          {current.code === 'he' ? 'עב' : 'EN'}
        </Typography>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {languages.map((lang) => (
          <MenuItem
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            selected={i18n.language === lang.code}
            sx={{ gap: 1.5 }}
          >
            <FlagImg src={lang.flag} alt={lang.label} />
            <Typography sx={{ fontSize: '0.9rem' }}>{lang.label}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSwitcher;
